module.exports = __webpack_public_path__ + "img/speaker1.e150c55a.png";